/* eslint semi:0 */
import React from 'react'
import { allTrue, } from '../../jsCore/utils/fn'
import { getIsDesktop, } from '../../jsCore/utils/ua'
import { connect, } from 'react-redux'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { t, } from '../../jsCore/providers/i18nProvider/i18nProvider'
import { MOUNT_POINTS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { cookieDisclaimerReducer, } from './cookieDisclaimerReducer'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { CookieDisclaimerComponent, classNameBlock, } from './cookieDisclaimerComponent'
import { getRequestUrl, getPageLocale, isSupportedForDomain, } from '../../jsCore/application/pageDataObject'
import {
  cookieDisclaimerGetHideFlag, closeCookieDisclaimerForever,
} from './cookieDisclaimerActions'


const COOKIE_DISCLAIMER_FEATURE_ID = 'CookieDisclaimer'
const pageLocalePath = getPageLocale() === 'en' ? '' : `${ getPageLocale() }/`
const PRIVACY_LINK = `//${ getRequestUrl() }/${ pageLocalePath }privacy`
const COMPONENT_NAME = 'CookieDisclaimerContainer'
const STATE_KEY = 'cookieDisclaimer'
const CSS_TRANSITION_NAME = `${ classNameBlock.transitionedmessage }`.split(' ')[1]


export class CookieDisclaimer extends React.Component {

  componentWillMount(){
    this.props.dispatch(cookieDisclaimerGetHideFlag())
  }

  closeForever(){
    const { dispatch, intervalId, } = this.props
    dispatch(closeCookieDisclaimerForever(intervalId))
  }

  get cookieDisclaimerComponentWithProps(){
    return (
      <CookieDisclaimerComponent
        link={ PRIVACY_LINK }
        onClick={ this.closeForever.bind(this) }
        text={ t('post_page.cookies_consent_1') }
        linkText={ t('post_page.cookies_consent_2') }
      />
    )
  }

  get cookieDisclaimerWithTransition(){
    const cssTransitionProps = {
      transitionName: CSS_TRANSITION_NAME,
      transitionAppear: true,
      transitionAppearTimeout: 4000,
      transitionEnterTimeout: 1000,
      transitionLeaveTimeout: 1000,
    }
    return (
      <ReactCSSTransitionGroup { ...cssTransitionProps }>
        { this.cookieDisclaimerComponentWithProps }
      </ReactCSSTransitionGroup>
    )
  }

  get currentView(){
    return !this.props.hide ? this.cookieDisclaimerWithTransition : false
  }

  render(){
    return this.props.isInitialized ? this.currentView : false
  }
}

function mapStateToProps(state){
  const { isInitialized, hide, intervalId, } = state.cookieDisclaimer
  return { isInitialized, hide, intervalId, }
}

const CookieDisclaimerContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps)(CookieDisclaimer),
  reducer: cookieDisclaimerReducer,
}

function mountCookieDisclaimer(){
  return reduxMount({
    [MOUNT_POINTS.COOKIE_DISCLAIMER]: CookieDisclaimerContainer,
  })
}

export default function initCookieDisclaimer(...predicates){
  const shouldMountCookieDisclaimer = allTrue(
    getIsDesktop(),
    isSupportedForDomain(COOKIE_DISCLAIMER_FEATURE_ID),
    ...predicates
  )
  if (shouldMountCookieDisclaimer) {
    mountCookieDisclaimer()
  }
  return shouldMountCookieDisclaimer
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/cookieDisclaimer/cookieDisclaimerContainer.js